// package
import { X } from 'lucide-react';

{/* 右上角關閉/返回按鈕 */ }
export default function CloseButton({ btnColor = '', ...props }) {
    return (
        <button
            type="button"
            aria-label="返回"
            className={`absolute top-4 right-4 z-50 w-8 h-8 flex items-center justify-center rounded-full bg-white/50 hover:bg-white hover:text-[#3E362E] transition-colors shadow-sm cursor-pointer ${btnColor ? btnColor : 'text-[#6E625B]'}`}
            {...props}
        >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
    );
};